import { formatNumber, formatMoney, formatPercentage, formatDateTime } from '@/utils/CommonUtils'


export default {
  // @ts-expect-error
  install(Vue) {
    Vue.filter('formatNumber', formatNumber)
    Vue.filter('formatMoney', formatMoney)
    Vue.filter('formatPercentage', formatPercentage)
    Vue.filter('formatDateTime', formatDateTime)
  }
}
